import { useAuthStore } from '@/src/features/app/store/auth/store';
import { PropsWithChildren, useEffect } from 'react';
import { AuthContext } from '@/src/features/app/store/auth/context';
import i18n from 'i18next';

export const AuthContextProvider = ({ children }: PropsWithChildren) => {
  const store = useAuthStore();

  useEffect(() => {
    void store.init();
    void i18n.changeLanguage(store.state.lang);
  }, []);

  return (
    <AuthContext.Provider value={store}>
      {children}
    </AuthContext.Provider>
  );
};
